import React from 'react';

import Loader from '../../components/Loader';
import DocumentView, { DocumentViewBox } from '../../components/ViewPage/Document';
import InfoTable from '../../components/ViewPage/InfoTable';
import CancelImg from '../../images/SideBar/Cancel';
import { formatDate, Roles } from '../../util/constant';
import useProfile from './useProfile';

export default function Profile() {
  const { userData, loading, role, document } = useProfile();
  console.log("userData", userData);

  const userInfo = {
    Name: userData?.name,
    Email: userData?.email,
    "Date Of Joining": formatDate(userData?.doj),
    Role: userData?.role,
  };

  const addressInfo = {
    Department: userData?.department,
    Designation: userData?.designation,
    Status: userData?.status,
  };
  const employeeInfo = {
    // "Employee ID": userData?.employeeId,
    Email: userData?.email,
    "Phone Number": userData?.phoneNo,
    "Created Date": userData?.createdDateTime?.toString().split("T")[0],
    Role: userData?.role,
  };

  const businessInfo = {
    "Business Name": userData?.businessName,
    "GST Number": userData?.gstNo,
    Language: userData?.language,
    "Business Type": userData?.businessType,
  };

  const bankInfo = {
    "Account Number": userData?.accountNo,
    "Account Name": userData?.accountName,
    "IFSC Code": userData?.IFSCCode,
    "Branch Name": userData?.branchName,
    "Branch Address": userData?.branchAddress,
  };
  const customerSupportInfo = {
    // "CustomerSupport ID": userData?.customerSupportId,
    Email: userData?.email,
    "Phone Number": userData?.phoneNo,
    "Created Date": userData?.createdDateTime?.toString().split("T")[0],
    Role: userData?.role,
  };

  const basicInfo = {
    "Date Of Joining": userData?.dateOfJoining,
    "Working Hours": userData?.workingHours,
    Language: userData?.language,
    "Emergency Contact Name": userData?.emergencyContactName,
    "Emergency Contact PhoneNo": userData?.emergencyContactPhoneNo,
    "Emergency Contact Relationship": userData?.emergencyContactRelationship,
  };
  const serviceStationDataInfo = {
    "ServiceStation Name": userData?.serviceStationName,
    "Working Hours": userData?.workingHours,
    "Gst No.": userData?.gstNo,
    Language: userData?.language,
    Agreement: userData?.isAgreement === "true" ? "Yes" : "No",
    "Created At": userData?.createdDateTime?.toString().split("T")[0],
  };

  const personalInfo = {
    phoneNo: userData?.phoneNo,
    Address: userData?.address,
    city: userData?.city,
    state: userData?.state,
    zipCode: userData?.zipCode,
    Role: userData?.role,
  };

  const BasicInfo = {
    "EV Charging": userData?.evCharging === "true" ? "Yes" : "No",
    "Charging Port Operation Hours":
      userData?.evCharging === "true"
        ? userData?.chargingPortOperationHours
        : "-",
    "Battery Replacement":
      userData?.BatteryReplacement === "true" ? "Yes" : "No",
    MaintenanceAndRepairs:
      userData?.MaintenanceAndRepairs === "true" ? "Yes" : "No",
  };
  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      {loading && <Loader />}
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 flex justify-between items-center px-6 py-4">
          <h1 className="text-3xl text-fontBlack">Profile</h1>
          <button onClick={() => window.history.back()}>
            <CancelImg />
          </button>
        </div>
        {role === Roles.admin ? (
          <div className="space-y-6 p-6 h-[70vh] overflow-y-auto bg-mainBg">
            <div className="flex bg-white rounded-xl">
              <div className="flex w-1/2 border-r border-border">
                <img
                  src={`${document?.photo}`}
                  alt="CustomerSupport Img"
                  className="w-36 h-36 rounded-lg border border-border mb-4 m-9"
                />
                <div className="text-black text-lg font-normal m-3 mt-10">
                  <p>Name: {userData?.fullName}</p>
                  <p>Status: {userData?.status}</p>
                </div>
              </div>
              <div className="m-3 mr-5 mb-5 w-1/2">
                <InfoTable
                  data={customerSupportInfo}
                  title="CustomerSupport Info"
                />
              </div>
            </div>
            <div className="flex bg-white rounded-xl">
              <div className="w-1/2 p-4 border-r border-border">
                <InfoTable data={basicInfo} title="Business Info" />
              </div>
              <div className="m-3 mr-5 mb-5 w-1/2">
                <InfoTable data={employeeInfo} title="Employee Info" />
              </div>
            </div>
            <div className="flex bg-white rounded-xl">
              <div className="w-1/2 p-4 ">
                <DocumentViewBox>
                  <DocumentView Title="Resume" Link={`${document?.resume}`} />
                  <DocumentView
                    Title="EDU Certificate"
                    Link={`${document?.eduCertificate}`}
                  />
                  <DocumentView
                    Title="Pan Card"
                    Link={`${document?.panCard}}`}
                  />
                  <DocumentView
                    Title="Address Proof"
                    Link={`${document?.addressProof}`}
                  />
                </DocumentViewBox>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6 p-6 h-[70vh] overflow-y-auto bg-mainBg">
            <div className="flex bg-white rounded-xl">
              <div className="w-1/2 m-3 mr-5 mb-5 border-r border-border">
                <InfoTable data={userInfo} title="User Info" />
              </div>
              <div className="m-3 mr-5 mb-5 w-1/2">
                <InfoTable data={addressInfo} title="Employee Info" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
